import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import drivewayHeader from '../_content/driveway3.webp'
import drivewayExample1 from '../_content/driveway2.webp'
import drivewayExample2 from '../_content/driveway.webp'
import drivewayExample3 from '../_content/driveway5.webp'
import drivewayExample4 from '../_content/IMG_3317.webp'
import drivewayExample5 from '../_content/driveway4.webp'
import drivewayExample6 from '../_content/after12.webp'
import drivewayExample7 from '../_content/driveway6.webp'
import drivewayExample8 from '../_content/driveway7.webp'
import drivewayExample9 from '../_content/driveway8.webp'
import drivewayExample10 from '../_content/driveway9.webp'

const DrivewayServices = () => {
  return (
    <>
      <ServicesHeader
        background={drivewayExample8}
        text="Driveway Services"
      />

      {/* TOP STRIP */}
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          Durable, high-quality driveways designed to improve access and enhance your Essex home.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      {/* WHITE SECTION */}
      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Driveways built for strength and kerb appeal
            </Typography>

            <Typography className="section-subtext">
              Whether you need a new driveway or want to upgrade your current surface, we deliver long-lasting results that look great and perform reliably.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                {
                  title: 'Built to Last',
                  text: 'We construct driveways designed to handle daily use and withstand the elements for years to come.',
                },
                {
                  title: 'Enhanced Appearance',
                  text: 'A professionally installed driveway improves the overall look and value of your property.',
                },
                {
                  title: 'Low Maintenance',
                  text: 'Our materials and finishes are chosen to keep upkeep simple while maintaining a clean, polished look.',
                },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      {/* IMAGE SECTION */}
      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[drivewayExample9, drivewayExample8, drivewayExample1, drivewayExample6, drivewayExample7, drivewayExample4, drivewayExample3, drivewayExample10, drivewayHeader, drivewayExample5, drivewayExample2].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Driveway example ${i + 1}`}
                  className="image-media"
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default DrivewayServices